import { Box, BoxProps, ScrollArea, Stack } from '@mantine/core'
import useStyles from './index.styles'
import { Text } from '@hhgtech/hhg-components/mantine'
import Quote from 'components/atoms/icons/Quote'
import { useIsMobile } from 'hooks/useIsMobile'

export type QuotationItem = {
  name: string
  message: string
}

type Props = { iconColor?: string } & QuotationItem & BoxProps

export const QuotationCard = ({
  message,
  name,
  className,
  classNames,
  styles,
  iconColor,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'QuotationCard',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  return (
    <Stack spacing={8} className={cx(classes.root, classes.root)} {...rest}>
      <Quote size={40} color={iconColor} />
      <Box className={classes.content}>
        <ScrollArea
          h={isMobile ? 168 : 144}
          scrollbarSize={6}
          offsetScrollbars
          styles={{
            thumb: {
              backgroundColor: '#d9d9d9',
            },
          }}
        >
          <Text size="p1">{message}</Text>
        </ScrollArea>
      </Box>

      <Box className={classes.authorBox}>
        <Box className={classes.divider}></Box>
        <Text size="p4" as="div" className={classes.author}>
          {name}
        </Text>
      </Box>
    </Stack>
  )
}
